import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AutoRefreshIndicator from './AutoRefreshIndicator';
import api from '../../../connection/api';

export default function TopBar({ username, onLogout, onToggleSidebar, isMobile }) {
  const navigate = useNavigate();
const [usernamee,setUsernamee]=useState(localStorage.getItem('username'));
  useEffect(() => {
    if (localStorage.getItem('token')) {
      if (localStorage.getItem('role') === 'admin') {
        // Don't auto-navigate if already on admin page to prevent refresh issues
        if (!window.location.pathname.startsWith('/admin')) {
          navigate('/admin/dashboard');
        }
      } else if (localStorage.getItem('role') === 'user') {
        navigate('/chawder/Home');
      }
    } else {
      navigate('/');
    }
  }, [navigate]);

  const handleLogout = async() => {
    
    // Clear token and redirect to login
    const token = localStorage.getItem("token");
    const ip=localStorage.getItem("ip")||'no ip';

    const response = await api.post("/logout",{ip:ip}, {
      headers: { Authorization: `Bearer ${token}`,
      "Content-Type": "application/json"
     },
     });

     if(response.data.success===true)
     {
      localStorage.clear();
      navigate('/');
     }
    
  };

  return (
    <header className="top-bar">
      <div className="top-bar-content">
        <div className="user-info">
          {isMobile && (
            <button 
              className="hamburger-menu" 
              onClick={onToggleSidebar}
              aria-label="Toggle menu"
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          )}
          <span className="welcome-text">بەخێربێیت، {usernamee || 'بەڕێوەبەر'}</span>
          <div className="user-avatar">
            <i className="fas fa-user-circle"></i>
          </div>
        </div>
        <div className="top-bar-actions">
          <AutoRefreshIndicator />
          <button className="logout-btn" onClick={handleLogout}>
            <i className="fas fa-sign-out-alt"></i>
            دەرچوون
          </button>
        </div>
      </div>
    </header>
  );
}
